import gsap from 'gsap'

export default function(sections) {
  const cursor = document.querySelector('.slider-cursor')
  const triggers = document.querySelectorAll('.trigger-cursor')

  gsap.set(cursor, {
    xPercent: -50,
    yPercent: -50,
  })

  sections.forEach(section =>
    section.addEventListener('pointermove', moveCursor)
  )

  triggers.forEach(img => {
    img.addEventListener('mouseenter', () => {
      cursor.classList.add('show')
    })
    img.addEventListener('mouseleave', () => {
      cursor.classList.remove('show')
    })
  })

  function moveCursor(e) {
    gsap.to(cursor, {
      duration: 0.3,
      x: e.clientX,
      y: e.clientY,
    })
  }
}
